<template>
  <q-card-section class="funButton font-size-14 no-padding q-mx-lg">
    <div class="btnList">
      <q-btn
        v-if="storeInfo.dineIn"
        no-caps
        unelevated
        :class="{ only: isOnlyBtn }"
        @click="goList('DINE_IN')"
      >
        <img :src="icons.dineIn" alt srcset />
        {{ customize['DINE_IN'] }}
        <span class="iconfont right-icon">&#xe744;</span>
      </q-btn>
      <q-btn
        v-if="storeInfo.pickUp"
        no-caps
        unelevated
        :class="{ only: isOnlyBtn }"
        @click="goList('PICK_UP')"
      >
        <img :src="icons.pickUp" alt srcset />
        {{ customize['PICK_UP'] }}
        <span class="iconfont right-icon">&#xe744;</span>
      </q-btn>
      <q-btn
        v-if="storeInfo.fullDineIn && table"
        no-caps
        unelevated
        :class="{ only: isOnlyBtn }"
        @click="goList('FULL_DINE_IN')"
      >
        <img :src="icons.dineIn" alt srcset />
        {{ customize['FULL_DINE_IN'] }}
        <span class="iconfont right-icon">&#xe744;</span>
      </q-btn>
      <q-btn
        v-if="storeInfo.delivery"
        no-caps
        unelevated
        :class="{ only: isOnlyBtn }"
        @click="goList('DELIVERY')"
      >
        <img :src="icons.delivery" alt srcset />
        {{ customize['DELIVERY'] }}
        <span class="iconfont right-icon">&#xe744;</span>
      </q-btn>
    </div>
  </q-card-section>
</template>

<script setup>
import { defineProps, ref, computed, onMounted } from 'vue';
import { useIns, useStore } from 'src/utils/v2_helper/common';
import { useRoute, useRouter } from 'src/utils/v2_helper/router';
import { useStoreCloseDialog } from 'src/utils/hooks/useStoreCloseDialog';
import { setTable, getTable, clearTable } from '../../../utils/common';

const app = useIns();
const store = useStore();
const route = useRoute();
const router = useRouter();
const { push: storeCloseDialogProvide } = useStoreCloseDialog();
const props = defineProps({
  icons: {
    type: Object,
    default: () => ({
      pickUp:
        'https://static.bakmigm.co.id/menu/Pickup.png',
      dineIn:
        'https://static.bakmigm.co.id/menu/7c15783ace60c63d5aefee0fa5b2cb0e.png',
      delivery:
        'https://static.bakmigm.co.id/menu/9d361a344a8bc5437c2d3ccc91991227.png',
    }),
  },
  status: {
    type: Object,
    default: () => {},
  },
  info: {
    type: Object,
    default: () => {},
  },
});

const table = ref('');

const customize = computed(() => app.storeInfo.customize);
const isOnlyBtn = computed(
  () =>
    // 计算结果 参考 true + true + false + true
    app.storeInfo.pickUp +
      app.storeInfo.dineIn +
      (app.storeInfo.fullDineIn && app.table) +
      app.storeInfo.delivery ===
    1,
);
const nearestStatus = computed(() => store.state.Menu.nearestStatus);

function handleGoList(type) {
  const url = route.params.store;
  store.commit('Menu/updateAccessStatus', type);
  store.commit('Menu/updateScheduled', false);
  storeCloseDialogProvide(type);
  router.push({
    path: `/${url}/products-list`,
    query: { table: table.value },
  });
}
function goList(type) {
  if (type === 'DELIVERY') {
    if (props.info && props.info.chainStore && !nearestStatus.value) {
      store.commit('Menu/updateAccessStatus', type);
      store.commit('Menu/updateScheduled', false);
      app.$emit('showNearest');
    } else {
      handleGoList(type);
    }
  } else {
    handleGoList(type);
  }
}

onMounted(() => {
  table.value = route.query.table || getTable();
  if (table.value) {
    setTable(table.value, 1000 * 60 * 60 * 12);
  } else {
    clearTable();
  }
});
</script>

<style lang="scss" scoped>
.funButton {
  margin-top: 12px;
  .btnList {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .q-btn {
    background: #fff;
    display: block;
    height: 94px;
    margin: 4px;
    margin-top: 0;
    border-radius: 10px;
    color: $black;
    font-weight: 800;
    word-break: keep-all;
    flex: 1;
    :deep(.q-btn__content) {
      flex-direction: column;
      line-height: 1.2;
    }
    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
    // .iconfont {
    //   font-size: 18px;
    //   color: $primary;
    //   margin-bottom: 8px;
    //   padding: 2px;
    //   background: $primary02;
    //   width: 26px;
    //   height: 26px;
    //   border-radius: 50%;
    //   line-height: 1.2;
    // }
    img {
      width: 34px;
      margin-bottom: 6px;
    }
    .right-icon {
      display: none;
      background: transparent;
      color: $primary;
      font-size: 20px;
      position: absolute;
      right: 8px;
    }
    &.only {
      background: #ffffff;
      color: $black;
      width: 100%;
      border-radius: 8px;
      font-weight: bold;
      font-size: 14px;
      line-height: 18px;
      padding: 6px 0;
      margin-bottom: 12px;
      height: 48px;
      position: relative;
      margin: 0;
      :deep(.q-btn__content) {
        flex-direction: row;
        // .iconfont {
        //   margin-bottom: 0;
        //   margin-right: 10px;
        // }
        img {
          width: 24px;
          margin-bottom: 0;
          margin-right: 6px;
        }
        .right-icon {
          display: block;
        }
      }
      & + .only {
        margin-top: 16px;
      }
    }
  }
  // .q-btn {
  //   background: $primary;
  //   color: #ffffff;
  //   width: 100%;
  //   border-radius: 8px;
  //   font-weight: bold;
  //   font-size: 14px;
  //   line-height: 18px;
  //   padding: 6px 0;
  //   margin-bottom: 12px;
  //   &:last-child {
  //     margin-bottom: 0;
  //   }
  // }
}
</style>
